/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })

export class SessionIdleService {
  private onUserInactivityLimit: Subject<void> = new Subject();
  private onUserWarningLimit: Subject<number> = new Subject();
  public onUserInactivityLimit$ = this.onUserInactivityLimit.asObservable();
  public onUserWarningLimit$ = this.onUserWarningLimit.asObservable();

  public constructor(private idle: Idle) {
    this.idle.setIdle(environment.userSession.inactivityWarning);
    this.idle.setTimeout(environment.userSession.inactivityLogout - environment.userSession.inactivityWarning);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onTimeoutWarning.subscribe(countdown => {
      this.onUserWarningLimit.next(countdown);
    });

    this.idle.onTimeout.subscribe(() => {
      this.onUserInactivityLimit.next();
    });
  }
  public beginIdleTracking(): void {
    this.idle.watch();

  }
  public endIdleTracking(): void {
    this.idle.stop();
  }
}
